import { GetterTree } from 'vuex'

import { change, onSnapshot } from './helpers'

import Plant from '@/models/Plant'

import { auth, db, serverTimestamp } from '@/firebase'

import harvests from '@/store/plants.harvests'
import { id } from '@/types/models'
import {
  RootState,
  PlantState,
  PlantContext,
  PlantUpdateInterface,
} from '@/types/store'
import { PlantInput } from '@/ui/components/AddPlant.vue'
// import { updateDoc, where } from "firebase/firestore";

export default {
  namespaced: true,
  modules: {
    harvests,
  },
  state: (): PlantState => ({
    data: [],
    unbinds: [],
  }),
  getters: {
    all: (state: PlantState) => state.data,
    inGarden: (state: PlantState) => (gardenId: id) =>
      state.data.filter((p: Plant) => p.gardenId === gardenId),
    filter: (state: PlantState) => (plantIds: id[]) =>
      state.data.filter((p: Plant) => plantIds.includes(p.id)),
    plant: (state: PlantState) => (plantId: id) =>
      state.data.find((p: Plant) => p.id === plantId),
    find: (state: PlantState, getters) => (plantId: id) =>
      getters['plant'](plantId),
  } as GetterTree<PlantState, RootState>,
  mutations: {
    change,
    clear(state: PlantState) {
      state.data = []
    },

    addUnbind(state: PlantState, val: () => void) {
      state.unbinds.push(val)
    },
  },
  actions: {
    bind(context: PlantContext, gardenId: id) {
      const unsubscribe = db.onCollectionSnapshot(
        db.query(
          db
            .collection('gardens', gardenId, 'plants')
            .withConverter(Plant.firestoreConverter(gardenId))
          // db.where(`roles.${auth.currentUser()?.uid}`, "in", ["owner"])
        ),
        (ref) => onSnapshot(context, ref)
      )

      // save unbind function to store
      context.commit('addUnbind', unsubscribe)
    },
    unbind(context: PlantContext) {
      // unsubscribe from firestore
      context.state.unbinds.forEach((fn) => fn())

      // clear from vuex store
      context.commit('clear')

      // TODO: unbind children based on collections() instead of root
    },

    add(
      context: PlantContext,
      { gardenId, plant }: { gardenId: id; plant: PlantInput }
    ) {
      const collectionRef = db.collection('gardens', gardenId, 'plants')

      const {
        name,
        abbr,
        description,
        startDate,
        endDate,
        location,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ...notEditable
      } = plant

      return db.addDoc(collectionRef, {
        name,
        abbr,
        description,
        startDate,
        endDate: endDate || null,
        location,
        // timestamps
        createdBy: auth.currentUser()?.uid,
        createdAt: serverTimestamp(),
      })
    },
    update(
      context: PlantContext,
      { gardenId, id, updates }: PlantUpdateInterface
    ) {
      const docRef = db.doc('gardens', gardenId, 'plants', id)

      const {
        name,
        abbr,
        description,
        startDate,
        endDate,
        location,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        ...notEditable
      } = updates

      return db.updateDoc(docRef, {
        name,
        abbr,
        description,
        startDate,
        endDate: endDate || null,
        location,
        // timestamps
        updatedBy: auth.currentUser()?.uid,
        updatedAt: serverTimestamp(),
      })
    },
  },
}
